//Common.js
import Moon from "../packages/Moon";
import update from "immutability-helper";
import Snackbar from "components/Snackbar";

class Common {
	static clearSearch(star) {
		setTimeout(() => {
			star.setState({ searchValue: "", searchElements: null });
		}, 150);
	}

	static deepCopy(obj) {
		let clone = obj.constructor();
		for (var i in obj)
			clone[i] =
				typeof obj[i] == "object" && obj[i] !== null
					? Common.deepCopy(obj[i])
					: obj[i];
		return clone;
	}

	static compareObjects(obj1, obj2, checkLength = false) {
		if ((obj1 != null && obj2 == null) || (obj1 == null && obj2 != null))
			return true;
		let keys = Object.keys(obj1);
		if (checkLength) {
			if (keys.length != Object.keys(obj2).length) return true;
		}
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i];
			if (
				obj1[key] !== null &&
				typeof obj1[key] === "object" &&
				obj2[key] !== null &&
				typeof obj2[key] === "object"
			) {
				if (Common.compareObjects(obj1[key], obj2[key], true))
					return true;
			} else if (obj1[key] != obj2[key]) return true;
		}
		return false;
	}

	static setStyleToGridItem(elem, style, value) {
		const domElement = document.getElementById(elem.gridName + elem.key);
		if (domElement) domElement.style[style] = value;
	}

	static copyToClipboartd(input, title) {
		input.select();
		document.execCommand("copy");
		Snackbar.info(title + " has been copied to clipboard!");
	}

	static isDemo() {
		let url_string = window.location.href;
		let url = new URL(url_string);
		let demoParam = url.searchParams.get("demo");
		let demo =
			demoParam != null && demoParam > "0" && demoParam <= "9"
				? demoParam
				: false;
		return demo;
	}

	static scrollTo(element, to = 0, duration = 1000, scrollToDone = null) {
		const start = element.scrollTop;
		const change = to - start;
		const increment = 20;
		let currentTime = 0;

		const animateScroll = () => {
			currentTime += increment;

			const val = Common.easeInOutQuad(
				currentTime,
				start,
				change,
				duration
			);

			element.scrollTop = val;

			if (currentTime < duration) {
				setTimeout(animateScroll, increment);
			} else {
				if (scrollToDone) scrollToDone();
			}
		};

		animateScroll();
	}

	static easeInOutQuad = function(t, b, c, d) {
		t /= d / 2;
		if (t < 1) return (c / 2) * t * t + b;
		t--;
		return (-c / 2) * (t * (t - 2) - 1) + b;
	};
}

export default Common;
